export default __webpack_public_path__ + "static/media/insta.3ceaadb0.webp";